export function page(_ctx) {
    return {
        styles: {
            main: { bg_color: '#000000', bg_opa: 255, border_width: 0, border_color: '#ffffff' },
        },
    };
}
